import { Component } from 'react';
import { connect } from 'react-redux';

import TagTab from 'components/atoms/TagTab';
import { OPRN_PROFILE_WITHOUT_SEARCH, TIME_MODE_RANG_HOURS } from 'data/static';
import { bindActionCreators, Dispatch } from 'redux';
import {
    SetErrorHandlerAction,
    setErrorHandlerAction,
    ShowMessageAction,
    showMessageAction,
} from 'store/actions/errorsActions';
import { SetLayoutAction, setLayoutAction } from 'store/actions/layoutActions';
import { Layout, OpenModal, RootState } from 'types';
import { MapControlsInterface, MenuControlsInterface, ProfileControlsInterface } from 'types/functions';
import { SystemType } from 'types/system';
import { checkDifferent, clone } from 'utils/formHandlers';
import { translate } from 'utils/translate';
import { twclsx } from 'utils/twclsx';

interface TabsProps {
    mapControls: MapControlsInterface;
    profileControls: ProfileControlsInterface;

    // from Transit not from store
    openModelFunction: OpenModal;
    layout: Layout;

    //unused props
    setErrorHandlerAction: SetErrorHandlerAction;
    menuControls: MenuControlsInterface;
    system: SystemType;

    setLayoutAction: SetLayoutAction;
    showMessageAction: ShowMessageAction;
    mode: string;
}

interface TabsState {
    layout: Layout;

    tabsHistory: string[];
    mode: string;
}

class Tabs extends Component<TabsProps, TabsState> {
    constructor(props: TabsProps) {
        super(props);
        this.state = {
            mode: props.mode,
            layout: clone(props.layout),
            tabsHistory: [],
        };
    }

    static getDerivedStateFromProps(props: TabsProps, state: TabsState) {
        if (props.mode !== state.mode || checkDifferent(props.layout, state.layout)) {
            return {
                //@ts-ignore
                //TODO
                // tabsHistory: [...state.tabsHistory, ...props.tab],
                mode: props.mode,
                layout: props.layout,
            };
        }

        return null;
    }

    openProfile = () => {
        this.props.mapControls.chart?.hideTooltips();
        const { status, message, messageType, searchDefined } = this.props.profileControls.checkProfile();
        console.log(searchDefined);
        if (status === false) {
            this.props.showMessageAction({
                messageType: messageType,
                message: message,
            });
        } else if (status === true) {
            if (OPRN_PROFILE_WITHOUT_SEARCH) {
                this.props.setLayoutAction([
                    { action: 'UPDATE_SECTION', data: { name: 'profile', state: true, display: true, disable: false } },
                ]);
                if (searchDefined) {
                    this.props.openModelFunction(
                        'profileOptionsModel',
                        0,
                        'medium',
                        {},
                        {
                            onCancel: () => {
                                this.props.openModelFunction('profileOptionsModel');
                            },
                            onConfirm: () => {
                                //console.log('saved')
                            },
                        },
                        true
                    );
                }
            } else {
                this.props.openModelFunction(
                    'profileOptionsModel',
                    0,
                    'medium',
                    {},
                    {
                        onCancel: () => {
                            this.props.openModelFunction('profileOptionsModel');
                        },
                        onConfirm: () => {
                            //console.log('saved')
                        },
                    },
                    true
                );
            }
        } else {
            this.props.setLayoutAction([
                { action: 'UPDATE_SECTION', data: { name: 'profile', state: true, display: true, disable: false } },
            ]);
        }
    };

    openReplay = () => {
        this.props.mapControls.chart?.hideTooltips();
        const checkReplay = this.props.layout.sections.playback?.data?.transit?.id
            ? this.props.layout.sections.playback.time
            : 0;
        const checkTime = this.props.layout.sections.time?.data?.startTime ? this.props.layout.sections.time.time : 0;
        if (!checkReplay && !checkTime && this.state.layout.viewMode !== 'live') {
            this.props.mapControls.time?.clearTooltips();
            this.props.menuControls.time?.refresh(true, true);
            this.props.setLayoutAction([
                {
                    action: 'UPDATE_MODE',
                    data: {
                        section: 'time',
                        mode: 'live',
                    },
                },
                {
                    action: 'UPDATE_MODE',
                    data: {
                        section: 'replay',
                        mode: 'live',
                    },
                },
                {
                    action: 'UPDATE_MODE',
                    data: {
                        section: 'replay',
                        mode: 'live',
                    },
                },
                {
                    action: 'UPDATE_DATA',
                    data: {
                        section: 'time',
                        data: {
                            startTime: this.props.system.date.today.clone().minus({ hours: TIME_MODE_RANG_HOURS }),
                            endTime: this.props.system.date.today,
                        },
                    },
                },
                {
                    action: 'UPDATE_SECTION',
                    data: { name: 'replay', loading: true, state: true, display: true, disable: false },
                },
                {
                    action: 'UPDATE_SECTION',
                    data: { name: 'time', loading: true, state: true, display: true, disable: false },
                },
                {
                    action: 'UPDATE_MENU',
                    data: {
                        name: 'timeMenu',
                        section: 'time',
                        state: true,
                    },
                },
            ]);
            // this.props.showMessageAction({
            //     messageType: 'INFO',
            //     message: 'Please select a time to playback or select a transit to replay.',
            // });
        } else if (checkReplay > checkTime) {
            this.props.setLayoutAction([
                { action: 'UPDATE_SECTION', data: { name: 'playback', state: true, display: false, disable: false } },
            ]);
        } else if (checkTime > checkReplay || (checkTime === checkReplay && this.state.layout.viewMode === 'live')) {
            this.props.setLayoutAction([
                { action: 'UPDATE_SECTION', data: { name: 'time', state: true, display: false, disable: false } },
            ]);
        }

        // else if (status === true) {
        //     this.props.openModelFunction(
        //         'profileOptionsModel',
        //         0,
        //         'medium',
        //         {},
        //         {
        //             onCancel: () => {
        //                 this.props.openModelFunction('profileOptionsModel');
        //             },
        //                            onConfirm: () => {
        // console.log('saved')
        //  },
        //         },
        //         true
        //     );
        // } else {
        //     this.props.setLayoutAction([
        //         { action: 'UPDATE_SECTION', data: { name: 'profile', state: true, display: true, disable: false } },
        //     ]);
        // }
    };

    getTransitAnalysisTooltip = () => {
        switch (this.state.mode) {
            case 'live':
            case 'time':
                return `${translate('Transit analysis')}<br/>
                        <div className="text-sm">${translate('Replay a time')}</div>`;
            case 'playback':
                return `${translate('Transit analysis')}<br/>
                        <div className="text-sm">${translate('Replay a transit')}</div>`;
            default:
                return `${translate('Transit analysis')}`;
        }
    };

    closeMeatOcean = () => {
        if (this.props.layout.sections.metOceanChart.data.backTo === 'chart') {
            this.props.setLayoutAction([
                {
                    action: 'CLOSE_SECTION',
                    data: { name: 'metOceanChart', state: false, display: false },
                },
            ]);
        } else {
            const checkReplay = this.props.layout.sections.playback?.data?.transit?.id
                ? this.props.layout.sections.playback.time
                : 0;
            const checkTime = this.props.layout.sections.time?.data?.startTime
                ? this.props.layout.sections.time.time
                : 0;

            if (checkReplay > checkTime) {
                this.props.setLayoutAction([
                    {
                        action: 'CLOSE_SECTION',
                        data: { name: 'metOceanChart', state: false, display: false },
                    },
                ]);
                this.openReplay();
            } else {
                this.props.setLayoutAction([
                    {
                        action: 'CLOSE_SECTION',
                        data: { name: 'metOceanChart', state: false, display: false },
                    },
                    {
                        action: 'UPDATE_SECTION',
                        data: { name: 'chart', state: true, display: true, disable: false },
                    },
                ]);
            }
        }
    };

    render() {
        return (
            <div
                className={twclsx(
                    // 'border-l',
                    'no-select',
                    'flex',
                    'ml-14',
                    'z-30',
                    'h-14',
                    'border-b',
                    'border-primary-systemSecondary',
                    'bg-white',
                    'w-full',
                    'fixed',
                    'bg-primary-system'
                )}
            >
                {Object.keys(this.state.layout.sections).map((section, i) => {
                    if (!this.state.layout.sections[section].display) {
                        return;
                    }
                    return (
                        <TagTab
                            first={i === 1}
                            openReplay={this.openReplay}
                            openProfile={this.openProfile}
                            closeMeatOcean={this.closeMeatOcean}
                            key={i}
                            section={section}
                            opend={
                                Object.keys(this.state.layout.sections).filter(
                                    (section) => this.state.layout.sections[section].display
                                ).length
                            }
                        ></TagTab>
                    );
                })}
            </div>
        );
    }
}

const tabsStateToProps = (state: RootState) => ({
    layout: state.layout.layout,

    mapControls: state.map.mapControls,

    update: state.port.update,
    mode: state.layout.mode,
    openModelFunction: state.layout.openModelFunction,
    profileControls: state.layout.profileControls,
    menuControls: state.layout.menuControls,
    system: state.port.system,
});

const tabsDispatchToProps = (dispatch: Dispatch) => ({
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
    showMessageAction: bindActionCreators(showMessageAction, dispatch),
    setLayoutAction: bindActionCreators(setLayoutAction, dispatch),
});

export default connect(tabsStateToProps, tabsDispatchToProps)(Tabs);
